// Workspace default dialing countries (dial code + label). Kept in sync with the
// backend _COUNTRY_NSN map in shared.py so E.164 auto-formatting works per country.
export const DIAL_COUNTRIES = [
    { code: "91", name: "India (+91)" },
    { code: "1", name: "United States / Canada (+1)" },
    { code: "44", name: "United Kingdom (+44)" },
    { code: "971", name: "United Arab Emirates (+971)" },
    { code: "65", name: "Singapore (+65)" },
    { code: "61", name: "Australia (+61)" },
    { code: "966", name: "Saudi Arabia (+966)" },
    { code: "63", name: "Philippines (+63)" },
    { code: "64", name: "New Zealand (+64)" },
    { code: "27", name: "South Africa (+27)" },
];
